import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  redeemMilesData: [],
  isLoading: false,
  hasData: false,
  error: "",
  directAwardsData: '',
  directAwardsError: ''
};
const redeemMilesSlice = createSlice({
  name: "redeemMiles",
  initialState,
  reducers: {
    redeemMilesRequest: state => {
      state.isLoading = true;
    },
    redeemMilesSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.error = "";
      state.redeemMilesData = action.payload.data;
    },
    redeemMilesFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    getDirectAwardsRequest: state => {
      state.isLoading = true;
    },
    getDirectAwardsSuccess: (state, action) => {
      state.isLoading = false;
      state.hasData = true;
      state.directAwardsContent = action.payload;
      state.directAwardsError = "";
    },
    getDirectAwardsFailure: (state, action) => {
      state.isLoading = false;
      state.hasData = false;
      state.directAwardsError = action.payload;
    }
  }
});
export const {
  redeemMilesRequest,
  redeemMilesSuccess,
  redeemMilesFailure,
  getDirectAwardsRequest,
  getDirectAwardsSuccess,
  getDirectAwardsFailure
} = redeemMilesSlice.actions;
export default redeemMilesSlice.reducer;